/* eslint-disable camelcase */
type Locale = 'en' | 'es';
type Phrase = (l: Locale) => string;

export const i18n_start_your_free_membership_trial: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `Start your free membership trial now to get this and thousands more practices on-demand!`,
    es: `Comienza ahora tu prueba gratis y obtén acceso ilimitado a miles de prácticas en línea.`,
  };
  return phrases[locale] || phrases.en || ``;
};
